// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__vveSq","question":"Question_question__MBWZS","description":"Question_description__V9_-r"};